/**
 * Which frame the hub draws, given where the athlete is and whether their
 * account is waiting to be deleted. While it is, every hub page shows only the
 * "due to be deleted" screen (DeletionPendingScreen), with nothing else of the
 * hub around it; the sign-in page stays itself, so they can get in to see it.
 */
export type HubFrame = 'bare' | 'deletion-pending' | 'hub';

export function hubFrameFor(pathname: string, deletionScheduledFor: string | null | undefined): HubFrame {
  if (pathname === '/hub/login') return 'bare';
  if (deletionScheduledFor) return 'deletion-pending';
  return 'hub';
}
